import { render } from "./PushNotification.vue?vue&type=template&id=001a02fa&scoped=true"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"

import "./PushNotification.vue?vue&type=style&index=0&id=001a02fa&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001a02fa"]])

export default __exports__